import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import TextInput from '../common/TextInput';
import PasswordInput from '../common/PasswordInput';
import LoadingSpinner from '../common/LoadingSpinner';
import useAPI from './useApi';
import useSocialLogin from './useSocialLogin';
import usePageTracking from '../lib/usePageTracking';

import Logo from '../assets/img/Kwenda-Logo.svg';
import styles from '../assets/css/auth.module.css';
import classNames from 'classnames';

const Login = () => {
  const [payload, setPayload] = useState({
    email: null,
    password: null,
  });
  const { status, actions: { login }, errors } = useAPI();
  const { loginWithFacebook, loginWithGoogle } = useSocialLogin({});
  usePageTracking();

  const update = (key, value) => {
    setPayload({ ...payload, [key]: value });
  };

  const submit = (e) => {
    e.preventDefault();
    login(payload);
  };

  return (
    <>
      <div className={styles.auth_main}>
        <div className={styles.auth_form}>
          <div className={styles.auth_form_header}>
            <div>
              <h2>تسجيل الدخول</h2>
              <p>مرحبا بعودتك إلى كويندا</p>
            </div>
            <Link to="/">
              <img className={styles.auth_logo} alt="Kwenda Logo" src={Logo} />
            </Link>
          </div>
          <form>
            <TextInput
              label="البريد الإلكتروني"
              type="text"
              placeholder="email@example.com"
              value={payload.email}
              onChange={(event) => update('email', event.target.value)}
              error={errors.email}
            />
            <PasswordInput
              value={payload.password}
              onChange={(event) => update('password', event.target.value)}
              error={errors.password}
            />
            <Link to="../forgot_password">هل نسيت كلمة المرور ؟</Link>
            <button className={classNames('button', styles.button)} onClick={submit}>
              تسجيل الدخول
              {status === 'submitting' && <LoadingSpinner />}
            </button>
            {errors.message && <p
              className="error centered">
              <span className="iconify" data-icon="zondicons:exclamation-solid">
              </span>
              {errors.message}
            </p>}

            <p className={styles.combined_link}>
              ليس لديك حساب ؟ <Link to="../signup">قم بإنشاء حساب جديد</Link>
            </p>
            <div className={styles.login_separator}>
              <div />
              <p>او</p>
              <div />
            </div>
            <div className='auth-social-login'>
              <p>قم بتسجيل الدخول عن طريق</p>
              <div className="social-login">
                <p onClick={e => {
                  e.preventDefault();
                  loginWithGoogle();
                }}>
                  <span className="iconify" data-icon="bi:google"></span>
                </p>

                <p onClick={e => {
                  e.preventDefault();
                  loginWithFacebook();
                }}>
                  <span className="iconify" data-icon="bi:facebook"></span>
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;
